import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../lib/auth';
import { Leaf } from 'lucide-react';

export default function AdminLogin() {
  const { t } = useTranslation();
  const { login, user, checking } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (checking) return <div className="min-h-screen grid place-items-center">…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      nav('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen bg-sand/40 grid place-items-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl border border-border-soft p-8 sm:p-10">
        <div className="flex items-center justify-center mb-6">
          <img src="/lawatan-logo.png" alt="Lawatan logo" className="h-20 w-auto" />
        </div>
        <h1 className="font-heading text-3xl text-ink">{t('admin.login_title')}</h1>
        <p className="text-ink-soft text-sm mt-1">{t('admin.login_sub')}</p>

        <div className="mt-6 grid gap-4">
          <div className="grid gap-2">
            <label className="overline">{t('admin.email')}</label>
            <input
              required type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="admin-email"
              className="rounded-xl border border-border-soft bg-bone px-4 py-3 outline-none focus:border-forest"
            />
          </div>
          <div className="grid gap-2">
            <label className="overline">{t('admin.password')}</label>
            <input
              required type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="admin-password"
              className="rounded-xl border border-border-soft bg-bone px-4 py-3 outline-none focus:border-forest"
            />
          </div>
          {error && <p className="text-red-700 text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary mt-2 disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? t('common.loading') : t('admin.login')}
          </button>
        </div>
      </form>
    </main>
  );
}
